import React, { useEffect, useState } from 'react';
import { useHistory, Link, Prompt } from 'react-router-dom';
import { Button, Flex, message, Spin, Typography, Form, Input, Select, Space, Segmented, Tag, Divider, Switch, Upload as AntUpload, Image } from 'antd';
import { Card, CardBody, Container } from 'reactstrap';
import { Col, Row } from 'react-bootstrap';
import Palette from '../../../utils/Palette';
import Iconify from '../../reusable/Iconify';
import swal from '../../reusable/CustomSweetAlert';
import Partner, { PARTNER_CATEGORIES } from 'models/PartnerModel';
import Upload from 'models/UploadModel';

export default function PartnerFormPage({
  partnerData,
  disabled,
}) {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState({
    save: false,
    saveDraft: false
  });
  const [form] = Form.useForm();
  const [formDisabled, setFormDisabled] = useState(false);
  const [language, setLanguage] = useState("ID");
  const [hasChanges, setHasChanges] = useState(false);

  const [logoPreview, setLogoPreview] = useState(null);

  const allowedImageType = ["image/jpg", "image/jpeg", "image/png", "image/webp"];

  const handleLogoUpload = async (file) => {
    if (!allowedImageType.includes(file.type)) {
      message.error("File must be image type " +
        allowedImageType.map((type) => type.slice(6).toUpperCase()).join(", "));
      return false;
    }
    const lessThan5MB = file.size / 1024 / 1024 < 5;
    if (!lessThan5MB) {
      message.error("Image must be smaller than 5MB.");
      return false;
    }
    try {
      const result = await Upload.uploadPicutre(file);
      form.setFieldValue("logo", result?.location);
      setLogoPreview(result?.location);
      message.success("Image uploaded successfully");
    } catch (e) {
      console.log("isi e", e);
      message.error("Failed to upload image");
    }
    return false;
  }

  const onValuesChanged = (changedValues, allValues) => {
    if (!partnerData) {
      const changed = Object.keys(allValues).some(key => {
        if (allValues[key]) {
          return true
        }
        return false
      })
      return setHasChanges(changed)
    }
    const changed = Object.keys(allValues).some(key => {
      if (!!allValues[key] && allValues[key] != partnerData[key]) {
        return true
      }
      return false
    })
    setHasChanges(changed)
  }

  const toggleLoadingSubmit = (action) => {
    setLoadingSubmit((prevLoadings) => {
      const newLoadings = { ...prevLoadings }
      newLoadings[action] = !prevLoadings[action];
      return newLoadings;
    })
  }

  const onSubmit = async (asDraft = false) => {
    if (asDraft) {
      form.validateFields()
      toggleLoadingSubmit("saveDraft")
    } else {
      toggleLoadingSubmit("save")
    }
    try {
      let result;
      let body;

      body = form.getFieldsValue()
      if (asDraft) {
        body["hide"] = true
      }
      console.log(body)

      let msg
      if (!partnerData) {
        msg = 'Successfully added new Partner'
        result = await Partner.create(body);
      } else {
        msg = 'Successfully updated Partner'
        result = await Partner.edit(partnerData.id, body);
      }

      message.success(msg)
      history.push("/partners")
    } catch (e) {
      console.log(e)
      let errorMessage = "An Error Occured"
      await swal.fire({
        title: 'Error',
        text: e.error_message ? e.error_message : errorMessage,
        icon: 'error',
        confirmButtonText: 'Okay'
      })
    } finally {
      if (asDraft) {
        toggleLoadingSubmit("saveDraft")
      } else {
        toggleLoadingSubmit("save")
      }
    }
  }

  const languageTag = (text, tagColor = Palette.MAIN_THEME) => (
    <span>
      {text} | {language}{" "}
      <Tag color={tagColor} style={{ fontSize: '10px', marginLeft: '8px' }}>
        Multi-Language
      </Tag>
    </span>
  );

  useEffect(() => {
    if (partnerData) {
      form.setFieldsValue({
        name: partnerData.name,
        name_tl: partnerData.name_tl,
        category: partnerData.category,
        hide: partnerData?.hide,
      })

      if (partnerData.logo) {
        form.setFieldValue("logo", partnerData.logo);
        setLogoPreview(partnerData.logo);
      } else {
        setLogoPreview(null);
      }
    }
    if (disabled) {
      setFormDisabled(disabled);
    }
  }, [partnerData])

  return (
    <>
      <Container fluid>
        <Card style={{ background: Palette.BACKGROUND_DARK_GRAY, color: "white" }}
          className="card-stats mb-4 mb-xl-0">
          <CardBody>
            <Row>
              <Col className='mb-3' md={6}>
                <Space align='center'>
                  <Link to={'/partners'}>
                    <Space align='center'>
                      <Iconify icon={'material-symbols:arrow-back-rounded'} style={{ fontSize: "16px", color: "white" }}></Iconify>
                    </Space>
                  </Link>
                  <span style={{ fontWeight: "bold", fontSize: "1.1em" }}>Partners</span>
                </Space>
              </Col>
            </Row>
            <Row>
              <Col className='mb-3' md={12} style={{ marginTop: "40px" }}>
                <Typography.Title level={3}>{!partnerData ? "Add" : "Update"} Partner</Typography.Title>
              </Col>
            </Row>
            <Row>
              <Col>
                {loading ? (
                  <Flex justify="center" align="center">
                    <Spin />
                  </Flex>
                ) : (
                  <Form
                    layout='vertical'
                    form={form}
                    onFinish={() => onSubmit(false)}
                    onValuesChange={onValuesChanged}
                    validateTrigger="onSubmit"
                    disabled={formDisabled}
                    autoComplete='off'
                  >
                    <Flex gap={"48px"} >
                      <Flex vertical style={{ width: "60%" }}>
                        <Flex justify='space-between' align='center'>
                          <Flex align='center' gap={12}>
                            <Typography.Text>
                              Mark as draft
                            </Typography.Text>
                            <Form.Item
                              label={"Mark as draft"}
                              name={"hide"}
                              valuePropName='checked'
                              noStyle
                            >
                              <Switch />
                            </Form.Item>
                          </Flex>

                          <Segmented
                            value={language}
                            style={{ marginBottom: 8 }}
                            onChange={setLanguage}
                            options={['ID', 'EN']}
                          />
                        </Flex>

                        <Divider>Details Information</Divider>

                        <Form.Item
                          label={"Category"}
                          name={"category"}
                          rules={[{
                            required: true,
                          }]}
                        >
                          <Select
                            variant='filled'
                            options={PARTNER_CATEGORIES}
                            placeholder="Select category"
                          />
                        </Form.Item>
                        <Form.Item
                          label={languageTag("Name")}
                          name={"name"}
                          rules={[{
                            required: true,
                          }]}
                          hidden={language !== "ID"}
                        >
                          <Input variant='filled' placeholder="e.g. Gramedia" />
                        </Form.Item>
                        <Form.Item
                          label={languageTag("Name")}
                          name={"name_tl"}
                          hidden={language === "ID"}
                        >
                          <Input variant='filled' placeholder="e.g. Gramedia" />
                        </Form.Item>

                        {!formDisabled ? (
                          <div className={"d-flex flex-row"} style={{ gap: "12px" }}>
                            <Button size="sm" type='primary' variant="primary" htmlType='submit' loading={loadingSubmit["save"]}>
                              {!partnerData ? "Add Partner" : "Save Partner"}
                            </Button>
                            {!partnerData ? (
                              <Button size="sm" type='default' onClick={() => onSubmit(true)} loading={loadingSubmit["saveDraft"]}>
                                {"Save As Draft"}
                              </Button>
                            ) : <></>
                            }
                          </div>
                        ) : (
                          <></>
                        )}
                      </Flex>
                      <Flex vertical style={{ width: "30%" }} className='text-white'>
                        <Typography.Text>Logo</Typography.Text>
                        <Flex vertical gap={8} style={{ marginTop: "8px" }}>
                          {logoPreview ? (
                            <Image
                              src={logoPreview}
                              width={"100%"}
                              style={{ objectFit: "contain", borderRadius: "6px", backgroundColor: "#fff" }}
                            />
                          ) : (
                            <></>
                          )}
                          <AntUpload
                            beforeUpload={handleLogoUpload}
                            showUploadList={false}
                            accept={allowedImageType.join(",")}
                          >
                            <Button size="sm" type='default'>
                              {logoPreview ? "Change Logo" : "Upload Logo"}
                            </Button>
                          </AntUpload>
                          <Typography.Text type="secondary" style={{ fontSize: "12px" }}>
                            Max image size 5MB. JPG, JPEG, PNG, WEBP supported.
                          </Typography.Text>
                        </Flex>
                        <Form.Item name={"logo"} noStyle>
                          <Input type="hidden" />
                        </Form.Item>
                      </Flex>
                    </Flex>
                  </Form>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
      <Prompt
        when={hasChanges && !(loadingSubmit["save"] || loadingSubmit['saveDraft'])}
        message={"Are you sure you want to leave before saving?"}
      />
    </>
  );
}
